import { Box, Collapse, CollapseProps, IconButton, makeStyles, Typography } from "@material-ui/core";
import * as React from "react";
import { SvgIcon } from "..";

const useStyles = makeStyles((theme) => ({
  info: {
    position: "relative",
    padding: "20px 40px 20px 20px",
    backgroundColor: "#ffffff",
  },
  infoTypography: {
    fontFamily: theme.typography.fontFamily,
    fontSize: 14,
    lineHeight: "16px",
    fontWeight: "normal",
    letterSpacing: -0.15,
    color: theme.palette.grey[600],
  },
  infoClose: {
    position: "absolute",
    right: "8px",
    top: "8px",
  },
  paddingZero: {
    padding: 0,
  },
}))

export interface BlockHintProps extends CollapseProps {
  onClose: () => void;
  borderBottom?: boolean;
  borderTop?: boolean;

}

export const BlockHint: React.FC<BlockHintProps> = ({children, onClose, borderTop, borderBottom, classes,...collapseProps}) => {
  const classesCustom = useStyles();
  return (
    <Collapse {...collapseProps}>
      <Box className={classesCustom.info} borderTop={borderTop ? "1px solid #E3E4E8" : undefined} borderBottom={borderBottom ? "1px solid #E3E4E8" : undefined}>
        <Typography className={classesCustom.infoTypography}>
          {children}
        </Typography>
        <Box className={classesCustom.infoClose}>
          <IconButton onClick={onClose} classes={{ root: classesCustom.paddingZero }}>
            <SvgIcon type="dialog-close small" />
          </IconButton>
        </Box>
      </Box>
    </Collapse>
  )
}

export default BlockHint;